import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        width: 'calc(100% - 32px)',
        '@media (max-width: 600px)': {
            height: 'var(--100vh)',
            width: '100% !important',
        },
    },
    '& .modal-base-content': {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        gridTemplateAreas: `"main sub"`,
        '@media (max-width: 600px)': {
            gridTemplateColumns: '100%',
            gridTemplateRows: '176px',
            gridTemplateAreas: `"sub" "main"`,
        },
    },
});

export const MainContent = styled('div')({
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gridArea: 'main',
});

export const SubContent = styled('div')({
    display: 'flex',
    alignItems: 'center',
    minHeight: 300,
    justifyContent: 'center',
    backgroundColor: '#F2F2F2',
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    gridArea: 'sub',
    '@media (max-width: 600px)': {
        minHeight: 'initial',
        height: 176,
    },
    '& svg, img': {
        width: 384,
    },
});

export const Form = styled('div')({
    display: 'grid',
    gridGap: '8px 24px',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    '@media (max-width: 1024px)': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        maxWidth: 'none',
    },
    '.combo-location-multiselect': {
        gridColumn: '1 / span 2',
    },
    '.react-colorful__wrapper': {
        position: 'absolute',
        top: '-70px !important',
        right: '-184px !important',
        zIndex: 2,
    },
    '@media (max-width: 768px)': {
        '.react-colorful__wrapper': {
            top: '-190px !important',
            left: '0 !important',
        },
    },
});
